import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/precautionary-index/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/precautionary-index",
)({
  component: Page,
});
